<template>
     <el-dialog  :visible.sync="modifyDialog" width="25%" top="15vh" center style="border: 1px solid #01DFD7" :close-on-click-modal = false
               :close-on-press-escape = false @close="closeDialog" :show-close= false>
        <el-card>
            <el-form ref="detailDialog" :model="request" label-width="80px">
                <el-form-item label="名称"><el-input v-model="request.name" clearable style="width: 250px"></el-input></el-form-item>
                <el-form-item label="权限">
                    <el-select v-model="request.newFunctions" multiple collapse-tags placeholder="请选择权限"  clearable style="width: 250px">
                        <el-option v-for="item in functions" :key="item.functionId" :label="item.name" :value="item.functionId"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
        </el-card>
        <span slot="footer" class="dialog-footer">
            <el-button style="background-color:#A9F5F2;margin: 0" @click="modifyDialog = false">取消</el-button>
            <el-button style="background-color:#A9F5A9" @click="modify">确定</el-button>
        </span>
     </el-dialog>
</template>
<script>
import {getFunction, modify} from '../../api/sys/position.js'
import {contains} from '../../utils/arrayUtils.js'
export default {
    data(){
        return {
            modifyDialog: false,
            request: {
                id: '',
                name: '',
                oldFunctions: [],
                newFunctions: [],
                type: ''
            },
            functions: [] 
        }
    },
    methods: {
        init(item){
            this.modifyDialog = true;
            this.request.id = item.id;
            this.request.name = item.name;
            this.request.oldFunctions = item.functions;
            this.request.type = item.type;
            switch(item.type){
                case "post": {
                    //获取权限列表
                    getFunction(null).then(result=>{
                        this.request.newFunctions = contains(result.data,item.functions);
                        this.functions = result.data;
                    })
                    break;
                }
                case "position": {
                    //获取权限列表
                    getFunction({roleGroupId: item.roleGroupId}).then(result=>{
                        this.request.newFunctions = contains(result.data,item.functions);
                        this.functions = result.data;
                    })
                    break;
                }
            }
            
        },
        modify(){
            modify(this.request).then(result=>{
                this.$emit("modify-succeed");
                this.$message({
                    message: "修改成功",
                    type: "success",
                    duration: 1500,
                });
                this.modifyDialog = false;
            })
        },
        closeDialog(){
            this.modifyDialog =  false;
            this.request.id = "";
            this.request.name = "";
            this.request.oldFunctions = [];
            this.request.newFunctions = [];
            this.request.type = "";
        }
    }
}
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/sys/modify.vue